import React from 'react';
import clsx from 'clsx';

import styles from './HighlightBadge.module.scss';

export enum HighlightBadgeText {
  BigWinForGettingStarted = 'Big win for getting started',
  EveryStepCounts = 'Every step counts',
  RightOnTrack = 'Right on track',
  MakingGreatProgress = 'Making great progress',
  AWeekAhead = 'A week ahead',
  AMonthAhead = 'A month ahead',
  HalfwayThere = 'Halfway there',
  YoureAlmostThere = "You're almost there",
  YouDidIt = '🙌 You did it!',
}

export enum HighlightBadgeType {
  Success = 'success',
  Gray = 'gray',
}

type HighlightBadgeTypeProps = { text: HighlightBadgeText; customText?: never } | { text?: never; customText: string };

type HighlightBadgeProps = HighlightBadgeTypeProps & {
  type?: HighlightBadgeType;
};

const HighlightBadge = ({ text, customText, type = HighlightBadgeType.Success }: HighlightBadgeProps) => {
  const displayText = customText || text;

  if (!displayText) return null;

  return <div className={clsx(styles.badge, styles[type])}>{displayText}</div>;
};

export default HighlightBadge;
